interface OtaUpdateBannerProps {
  applying: boolean;
  onApply: () => void;
}

/**
 * "Update available — Restart to apply" prompt (M5). Fixed above the bottom tab
 * bar (and its safe-area inset) so it never covers content or the nav. Only
 * rendered on native when a downloaded OTA bundle is waiting.
 */
export function OtaUpdateBanner({ applying, onApply }: OtaUpdateBannerProps) {
  return (
    <div
      role="status"
      className="fixed inset-x-3 bottom-[calc(4.5rem+env(safe-area-inset-bottom))] z-50 rounded-xl border border-bn-200 bg-bn-800 text-white shadow-lg"
    >
      <div className="flex items-center gap-3 px-4 py-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/15">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-4 w-4"
            aria-hidden="true"
          >
            <path d="M21 12a9 9 0 1 1-3-6.7" />
            <path d="M21 3v6h-6" />
          </svg>
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold">Update available</p>
          <p className="truncate text-xs text-white/70">Restart to apply the latest version.</p>
        </div>
        <button
          type="button"
          onClick={onApply}
          disabled={applying}
          className="shrink-0 rounded-lg bg-white px-3 py-1.5 text-sm font-semibold text-bn-800 transition hover:bg-white/90 disabled:opacity-60"
        >
          {applying ? 'Restarting…' : 'Restart'}
        </button>
      </div>
    </div>
  );
}
